<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon color="light" name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title translate>Indisponibilité immédiate</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="wrapper">
    <ion-label>Choisir indisponibilité</ion-label>
    <div class="lineSelection">
      <ion-input
        readonly
        (click)="changeMotif($event)"
        [ngModel]="motif"
        label="Type indisponibilité"
        label-placement="floating"
        fill="outline"
        id="popover-button"
      ></ion-input>
      <span class="dropdown-arrow">
        <ion-icon name="{{ isIconUp ? 'caret-up-outline' : 'caret-down-outline' }}" color="dark"></ion-icon>
      </span>
    </div>

    <ion-popover
      trigger="popover-button"
      (ionPopoverDidDismiss)="handleDismiss()"
      [dismissOnSelect]="true"
      show-backdrop="false"
      alignment="end"
    >
      <ng-template>
        <ion-list>
          <ion-radio-group [(ngModel)]="selectedOption">
            @for (option of accidentTypeOptions; let last = $last; track option) {
              <ion-item (click)="selectOption(option)" lines="{{ last ? 'none' : 'inset' }}">
                <ion-label>{{ option.label }}</ion-label>
                <ion-radio slot="end" [value]="option.value"></ion-radio>
              </ion-item>
            }
          </ion-radio-group>
        </ion-list>
      </ng-template>
    </ion-popover>

    <ion-grid no-padding>
      <ion-row>
        <ion-col no-padding class="ion-text-center date-row">
          <date-time-picker
            [defaultValue]="this.dateDebut().toISOString()"
            label="Commence"
            (valueChange)="changeDateDebut($event)"
          ></date-time-picker>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col no-padding class="ion-text-center date-row">
          <date-time-picker
            [defaultValue]="this.dateFin().toISOString()"
            label="Fini"
            (valueChange)="changeDateFin($event)"
          ></date-time-picker>
        </ion-col>
      </ion-row>
      @if (dureeTropCourte()) {
        <ion-row>
          <ion-label class="error">La durée minimale est de 30 minutes.</ion-label>
        </ion-row>
      }
    </ion-grid>
    <ion-label translate>
      Commentaire
      @if (isCommentaireFalcultatif()) {
        <span translate>Facultatif</span>
      }
    </ion-label>
    <ion-textarea
      [ngModel]="commentaire"
      (ngModelChange)="changeCommentaire($event)"
      type="text"
      placeholder="Votre message... "
      fill="outline"
    ></ion-textarea>
  </div>
</ion-content>
<ion-footer>
  <div class="footer">
    <ion-button
      expand="block"
      color="danger"
      (click)="validForm()"
      [disabled]="!this.commentaireValid() || this.dureeTropCourte() || this.isLoading()"
    >
      @if (this.isLoading()) {
        <ion-spinner></ion-spinner>
      } @else {
        <span translate>Valider</span>
      }
    </ion-button>
  </div>
</ion-footer>
